import { PageContextUtils, UrlUtils } from "../../../../utils";

import { config as defaultConfig } from "../../default/Kambi/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  bettingHistory: "/apuestas/",
  bettingRules: "/como-apostar/reglas-de-apuestas/",
  blog: "/blog/",
  casinoUrl: "https://www.888casino.es/",
  casinoNativeUrl: "https://casino-es.onelink.me/yp7C/CrossSellSportToCasino",
  sportUrl: getSportUrl(),
  contactUs: "https://www.888.es/contacto.htm",
  help: "https://888-external-espana.custhelp.com/app/home/p/815",
  home: "/",
  liveChat:
    "https://888-external-espana.custhelp.com/app/chat/chat_launch?chanel=888es_es_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-espana.custhelp.com/app/chat/chat_launch?chanel=888es_es_vip&ChRefId=3",
  liveNow: "/apuestas-en-vivo/",
  logoTypesRegulation: "https://www.888.es/juego-responsable/",
  logoTypesResponsibleGaming: "https://www.jugarbien.es/",
  logoTypesSelfExclude: "https://ordenacionjuego.es/es/rgiaj/",
  pokerUrl: "https://www.888poker.es/",
  pokerUrlAuthenticated: "https://www.888poker.es/abrir-software.htm",
  pokerNativeUrliOS:
    "https://poker-es.onelink.me/q0wn/CrossSellSportToPokeriOS",
  pokerNativeUrlAndroid:
    "https://poker-es.onelink.me/q0wn/CrossSellSportToPokerAndroid",
  promotions: "/promociones/",
  promotionsVIP: "/apuestas-deportivas-vip",
  responsibleGaming: "https://www.888.es/juego-responsable/",
  startingSoon: "/proximamente/",
  survey: clientPage,
  pokerHistoryLink: "/app/historial-de-poker/",
  recommendations: "/recomendaciones/",
  madeForYou: {
    es: "/hechoparati/parahoy/mfytoday/"
  },
  betFeed: "/betfeed/"
};

export const config = {
  ...defaultConfig,
  logo_VIP: "sport_logo_VIP"
};
